import { CONTACT, FOOTER_BLURB, NAV_LINKS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "./shared";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-navy pb-10 pt-24 text-white/70"
    >
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Reveal>
              <img
                src="/assets/oswal-logo.png"
                alt="OSWAL COSLABS PRIVATE LIMITED — official logo"
                className="h-auto w-[220px]"
                data-testid="footer-logo"
              />
              <p className="mt-7 max-w-sm text-[15px] leading-relaxed text-white/60">
                {FOOTER_BLURB}
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-3">
            <Reveal delay={0.1}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-white/40">
                Navigate
              </p>
              <nav className="mt-6 flex flex-col items-start gap-3" aria-label="Footer">
                {NAV_LINKS.map((link) => (
                  <button
                    key={link.id}
                    type="button"
                    onClick={() => scrollToId(link.id)}
                    data-testid={`footer-link-${link.id}`}
                    className="link-underline text-sm tracking-wide text-white/70 transition-colors hover:text-white"
                  >
                    {link.label}
                  </button>
                ))}
              </nav>
            </Reveal>
          </div>

          <div className="md:col-span-4">
            <Reveal delay={0.18}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-white/40">
                Reach Us
              </p>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email-link"
                className="link-underline mt-6 inline-block text-sm tracking-wide text-white/80"
              >
                {CONTACT.email}
              </a>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.28em] text-white/40">
                Corporate Office
              </p>
              <p className="mt-3 text-sm leading-relaxed text-white/50">
                {CONTACT.officeLines.join(" ")}
              </p>
              <p className="mt-3 text-[11px] uppercase tracking-[0.24em] text-white/40">
                Ahmedabad · Gujarat · India
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 flex flex-col justify-between gap-3 border-t border-white/10 pt-7 text-[11px] uppercase tracking-[0.22em] text-white/40 md:flex-row">
          <p>© 2026 OSWAL COSLABS PRIVATE LIMITED</p>
          <p>Quality · Affordability · Trust</p>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="watermark pointer-events-none absolute -bottom-[6vw] left-0 w-full text-center text-[30vw] leading-[0.72]"
      >
        OSWAL
      </div>
    </footer>
  );
}
